import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import Radial from '../Radial';
import C from '../Container';
import { ReactComponent as RadialSquiggle } from '../../svg/radial-squiggle.svg';

const Block = styled.div`
  width: 100%;
  margin: 2em 0;
  padding-bottom: ${props => (props.isLastItem ? '2em' : 0)};
  margin-left: -7.8rem;

  @media ${props => props.theme.breakpoints.small} {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
`;

const Container = styled(C)`
  /* display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0; */
  margin: 0 auto;
`;

const RadialOuter = styled.div`
  width: 100%;
  margin-bottom: 0.5em;
  max-width: 10em;
  margin-left: auto;

  @media ${props => props.theme.breakpoints.small} {
    margin: 0 auto 0.5em;
  }
`;

const RadialSquiggleStyled = styled(RadialSquiggle)`
  color: ${props => props.theme.colors.notWhite};
  height: auto;
  max-width: 10em;
  /**
   * Magic numbers: the svg & body copy have a max width of 10em. This takes
   * the remaining space and adds a 1em margin
   */
  width: calc(100% - 11em);
  margin-right: 1em;

  @media ${props => props.theme.breakpoints.small} {
    display: none;
  }
`;

const RadialBody = styled.div`
  display: flex;
  flex-flow: row;
  align-items: flex-start;
`;

const IntroStyled = styled.div`
  margin: 0;
  max-width: 10em;
`;

const RadialGraph = ({ fields, ...rest }) => {
  const { number, caption } = fields;
  return (
    <Block isLastItem={rest.index + 1 === rest.numberOfBlocks}>
      <Container>
        <RadialOuter>
          <Radial data={String(number)} />
        </RadialOuter>
        <RadialBody>
          <RadialSquiggleStyled />
          <IntroStyled>{caption}</IntroStyled>
        </RadialBody>
      </Container>
    </Block>
  );
};

RadialGraph.propTypes = {
  fields: PropTypes.shape({
    caption: PropTypes.string,
    number: PropTypes.number,
  }).isRequired,
};

export default RadialGraph;
